
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.62 22H.37a.38.38 0 010-.75h1.75v-6.66a5.17 5.17 0 01-1.4-6.85L3.6 2.72c.25-.44.73-.72 1.24-.72h14.34c.51 0 .99.28 1.24.72l2.86 5.01a5.21 5.21 0 01-1.38 6.86v6.66h1.73a.38.38 0 010 .75zm-20.75-.75h18.27v-6.23a4.5 4.5 0 01-1.7.53h-.03a5.12 5.12 0 01-3.98-1.3 5.12 5.12 0 01-6.87 0 5.11 5.11 0 01-4 1.3c-.66 0-1.27-.24-1.7-.47v6.17zm5.7-7.9c.1 0 .2.04.27.12a4.37 4.37 0 006.32 0c.14-.16.4-.16.54 0 .94.99 2.3 1.49 3.65 1.33h.06c.43 0 1.41-.44 1.9-.73a4.46 4.46 0 001.31-5.96L19.76 3.1a.68.68 0 00-.59-.35H4.83a.68.68 0 00-.6.35L1.38 8.12a4.44 4.44 0 001.36 5.99c.17.12.98.7 1.87.7a4.4 4.4 0 003.7-1.34.37.37 0 01.27-.12z"}})])
          )
        }
      }
    